<template>
  <div>
    <section class="mail-tips">
      <span style="font-size:14px; font-weight: bold;">送件上门须知</span>
      <p style="font-size:12px;">
        送件上门请自觉遵守
        <a href="javascript:;" style="color: blue; text-decoration:underline;" @click="agreement">《校圆通跑腿协议》</a>
        ，超过规定时间没有跑腿接单该跑腿单将自动作废，平台原路返回您的预付赏金。
      </p>
    </section>
    <div class="weui-cells weui-cells_form" style="margin-top: 0px;">
      <div class="weui-cell" style="color: #1aad19;">
        <div class="weui-cell__bd">
          <p>{{excName}}</p>
        </div>
        <div class="weui-cell__ft" style="color: #1aad19;">{{expressNo}}</div>
      </div>
    </div>
    <div class="weui-cells__title" style="color: red; font-weight: bold;">
      <i class="iconfont icon-warning" style="font-weight: bold;"></i>
      上门时间:{{expressNoonDoorServiceBegin}}-{{expressNoonDoorServiceEnd}} 或
      {{expressPmDoorServiceBegin}}-{{expressPmDoorServiceEnd}}
    </div>
    <div class="weui-cells weui-cells_form" style="margin-top: -1px;">
      <a class="weui-cell weui-cell_access" href="javascript:;" @click="showBuildingPicker">
        <div class="weui-cell__bd">
          <p>所在大楼</p>
        </div>
        <div class="weui-cell__ft">{{pickBuildingTxt?pickBuildingTxt:"请选择"}}</div>
      </a>
      <a class="weui-cell weui-cell_access" href="javascript:;" @click="showFloorPicker">
        <div class="weui-cell__bd">
          <p>所在楼层</p>
        </div>
        <div class="weui-cell__ft">{{pickFloor?pickFloor+"楼":"请选择"}}</div>
      </a>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">宿舍号码</label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" v-model="dormRoom" placeholder="请输入宿舍号码" style="text-align: right;" />
        </div>
      </div>
      <div class="weui-cell weui-cell_switch">
        <div class="weui-cell__bd">
          朋友代收
          <span style="color: red; font-size: 12px;">（选填）</span>
        </div>
        <div class="weui-cell__ft">
          <label for="switchCP" class="weui-switch-cp">
            <input id="switchCP" class="weui-switch-cp__input" type="checkbox" v-model="isProxy" />
            <div class="weui-switch-cp__box"></div>
          </label>
        </div>
      </div>
      <div class="weui-cell" v-if="isProxy">
        <div class="weui-cell__hd">
          <label class="weui-label">朋友姓名</label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" v-model="proxyReceiver" placeholder="代收必填" style="text-align: right;" />
        </div>
      </div>
      <div class="weui-cell" v-if="isProxy">
        <div class="weui-cell__hd">
          <label class="weui-label">朋友电话</label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" type="number" v-model="proxyReceiverPhone"
            oninput="if(value.length>11)value=value.slice(0,11)" placeholder="代收必填" style="text-align: right;" />
        </div>
      </div>
    </div>
    <div class="weui-cells__title">
      请选择您的物品类别
      <span class="need">*</span>
    </div>
    <div class="weui-cells weui-cells_checkbox">
      <label class="weui-cell weui-check__label" for="s11">
        <div class="weui-cell__hd">
          <input type="radio" class="weui-check" name="goodsType" id="s11" :disabled="size>1?true:false"
            @change="chooseGoodsType(1)" />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd" :class="size>1?'unable-radio':''">
          <p>小件物品（&lt;0.5kg）</p>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="s12">
        <div class="weui-cell__hd">
          <input type="radio" name="goodsType" class="weui-check" id="s12" :disabled="size>2?true:false"
            @change="chooseGoodsType(2)" />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd" :class="size>2?'unable-radio':''">
          <p>中件物品（0.5kg ~ 2kg）</p>
        </div>
      </label>
      <label class="weui-cell weui-check__label" for="s13">
        <div class="weui-cell__hd">
          <input type="radio" name="goodsType" class="weui-check" id="s13" @change="chooseGoodsType(3)" />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd">
          <p>大件物品（&gt;2kg）</p>
        </div>
      </label>
    </div>
    <div class="weui-cells__title" v-if="goodsType == 3">
      大件分类
      <span class="need">*</span>
    </div>
    <div class="weui-cells weui-cells_checkbox" v-if="goodsType == 3">
      <label class="weui-cell weui-check__label" :for="item._id" v-for="(item, index) in specialGoods" :key="index">
        <div class="weui-cell__hd">
          <input type="radio" class="weui-check" name="goodsDetail" :id="item._id" @change="chooseGoodsDetail(item)" />
          <i class="weui-icon-checked"></i>
        </div>
        <div class="weui-cell__bd">
          <p>{{item.name}}</p>
        </div>
      </label>
    </div>
    <div class="weui-cells__title">备注</div>
    <div class="weui-cells weui-cells_checkbox" style="margin-bottom: 10px;">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <textarea class="weui-textarea" v-model="remark" placeholder="请输入备注（选填）" rows="2"></textarea>
          <div class="weui-textarea-counter" :class="{'address-error':remark.length>50}">
            <span>{{remark.length}}</span>/50
          </div>
        </div>
      </div>
    </div>

    <div class="discount-info" v-if="discountInfo && discountInfo._id">
      <i class="iconfont icon-huo"></i>
      {{discountInfo.title}}活动火热进行中..
      <span v-if="canOrder && discount">已为您节省 ￥{{discount}} 元。</span>
      <span v-else-if="!canOrder">活动期间每天限量{{discountInfo.countDaily}}单。</span>
      <span v-if="discountInfo.remark">{{discountInfo.remark}}</span>
    </div>
    <div style="display: flex;">
      <div class="warehousing-footer-item shangjin" style="flex: 2">￥{{payFee}}元</div>
      <div class="warehousing-footer-item warehousing-footer-item-disable" style="flex:3" v-if="!canOrder">
        <a href="javascript:;">今天已满额</a>
      </div>
      <div class="warehousing-footer-item" style="flex:3" v-else @click="save">
        <a href="javascript:;" v-if="!payFee">提交跑腿单</a>
        <a href="javascript:;" v-if="payFee">去支付</a>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {},
      toTakeId: "",
      isBoxStorage: false,
      password: "",
      worksite: {},
      worksiteId: "",
      schoolCode: "",
      excName: "",
      expressNo: "",
      storageNo: "",
      tag: "",
      size: 1,
      expressNoonDoorServiceBegin: "12:00",
      expressNoonDoorServiceEnd: "14:00",
      expressPmDoorServiceBegin: "19:00",
      expressPmDoorServiceEnd: "23:00",
      weight: {},
      currHoure: "",
      requireArriveTime: "",
      requireArriveTimeLabel: "",
      doorServiceData: [],
      goodsType: null,
      goodsDetail: null,
      isProxy: false,
      proxyReceiver: "",
      proxyReceiverPhone: "",
      sexLimit: {
        value: -1,
        label: "不限"
      },
      fee: 0,
      payFee: 0,
      dormRoom: null,
      remark: "",
      discountInfo: {},
      discount: 0,
      canOrder: true,
      canDiscount: false,
      buildingPicker: null,
      buildings: [],
      pickBuildingId: null,
      pickBuildingTxt: null,
      initBuildingIndex: null,
      isLift: false,
      floorPicker: null,
      floors: [],
      initFloorIndex: null,
      pickFloor: null,
      specialGoods: [], // 如果选择的大楼定义有特殊大件，则使用该大楼自定义的，否则使用全局的
      liftSmallFee: null,
      liftMiddleFee: null,
      liftBigFee: null,
      smallFeeOne: null,
      smallFeeTwo: null,
      middleFeeOne: null,
      middleFeeTwo: null,
      bigFeeOne: null,
      bigFeeTwo: null
    };
  },
  created() {
    this.toTakeId = this.$route.params.toTakeId;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios.get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
        this.specialGoods = this.userInfo.worksite.specialGoods;
        this.specialGoods.push({
          _id: -1,
          name: "其他",
          liftFee: this.userInfo.worksite.liftBigFee,
          feeOne: this.userInfo.worksite.bigFeeOne,
          feeTwo: this.userInfo.worksite.bigFeeTwo
        });

        this.pickFloor = this.userInfo.dormFloor;
        this.dormRoom = this.userInfo.dormRoom;
        this.worksiteId = this.userInfo.worksite._id;
        let buildingInfo = this.userInfo.dormBuilding;

        axios.get("/api/worksite/detail/" + this.worksiteId)
          .then(res => {
            if (res.data.success) {
              this.expressNoonDoorServiceBegin = res.data.data.expressNoonDoorServiceBegin;
              this.expressNoonDoorServiceEnd = res.data.data.expressNoonDoorServiceEnd;
              this.expressPmDoorServiceBegin = res.data.data.expressPmDoorServiceBegin;
              this.expressPmDoorServiceEnd = res.data.data.expressPmDoorServiceEnd;
              this.worksite = res.data.data;

              if (buildingInfo) {
                this.pickBuildingId = buildingInfo._id;

                if (buildingInfo.area) {
                  axios.get("/api/area/getById/" + buildingInfo.area)
                    .then(res => {
                      if (res.data.success) {
                        this.pickBuildingTxt = res.data.data.name + "-" + buildingInfo.name + "(" + buildingInfo.tag + ")";
                      } else {
                        this.pickBuildingTxt = buildingInfo.name + "(" + buildingInfo.tag + ")";
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.pickBuildingTxt = buildingInfo.name + "(" + buildingInfo.tag + ")";
                    });
                } else {
                  this.pickBuildingTxt = buildingInfo.name + "(" + buildingInfo.tag + ")";
                }
                this.isLift = buildingInfo.isLift;

                this.liftSmallFee = buildingInfo.liftSmallFee || this.worksite.liftSmallFee;
                this.liftMiddleFee = buildingInfo.liftMiddleFee || this.worksite.liftMiddleFee;
                this.liftBigFee = buildingInfo.liftBigFee || this.worksite.liftBigFee;
                this.smallFeeOne = buildingInfo.smallFeeOne || this.worksite.smallFeeOne;
                this.smallFeeTwo = buildingInfo.smallFeeTwo || this.worksite.smallFeeTwo;
                this.middleFeeOne = buildingInfo.middleFeeOne || this.worksite.middleFeeOne;
                this.middleFeeTwo = buildingInfo.middleFeeTwo || this.worksite.middleFeeTwo;
                this.bigFeeOne = buildingInfo.bigFeeOne || this.worksite.bigFeeOne;
                this.bigFeeTwo = buildingInfo.bigFeeTwo || this.worksite.bigFeeTwo;

                if (buildingInfo.specialGoods && buildingInfo.specialGoods.length > 0) {
                  this.specialGoods = buildingInfo.specialGoods;
                  this.specialGoods.push({
                    _id: -1,
                    name: "其他",
                    liftFee: buildingInfo.liftBigFee,
                    feeOne: buildingInfo.bigFeeOne,
                    feeTwo: buildingInfo.bigFeeTwo
                  });
                }
              }

              axios
                .get("/api/expressTosend/getById/" + this.toTakeId)
                .then(res => {
                  if (res.data.success) {
                    let obj = res.data.data;
                    if (obj.type == 2) {
                      this.isBoxStorage = true;
                      this.password = obj.password;
                    }
                    this.excName = obj.expressCompany.name;
                    if (obj.size) {
                      this.size = obj.size;
                    }
                    // 目前没有针对超大件的收费，所以按照大件来计算
                    this.goodsType = this.size != 4 ? this.size : 3;
                    this.$nextTick(() => {
                      document.getElementById("s1" + this.goodsType).checked = true;
                      this.calculate();
                    });
                    this.expressNo = obj.expressNo;
                    this.schoolCode = obj.worksite.schoolCode;
                    this.weight = obj.weight;
                    this.storageNo = obj.storageNo;
                    this.tag = obj.tag;
                  } else {
                    weui.alert("获取快递信息出错");
                  }
                })
                .catch(err => {
                  weui.alert("获取快递信息出错");
                });
            } else {
              weui.alert("获取网点营业时间失败");
            }
          })
          .catch(err => {
            weui.alert("获取网点营业时间失败");
          });

        // 获取大楼列表
        axios
          .get("/api/building/list/" + this.worksiteId)
          .then(res => {
            if (res.data.success) {
              let list = res.data.data;
              for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.area) {
                  item.name = item.area.name + "-" + item.name;
                }
                if (item.tag) {
                  item.alias = item.name + "(" + item.tag + ")";
                } else {
                  item.alias = item.name;
                }
                this.buildings.push({
                  text: item.alias,
                  value: item._id,
                  isLift: item.isLift,
                  item: item
                });
              }
            } else {
              weui.alert("获取大楼列表失败");
            }
          })
          .catch(err => {
            weui.alert("获取大楼列表失败");
          });

        // 获取折扣活动
        axios
          .get("/api/active/one/1/" + this.worksiteId + "/1")
          .then(res => {
            if (res.data.success) {
              this.canOrder = res.data.canOrder;
              this.discountInfo = res.data.data;
              this.canDiscount = res.data.discount;
            }
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });

    this.currHoure = moment().format("HH");
  },
  mounted() { },
  methods: {
    agreement() {
      this.$router.push("/paotuiAgreement");
    },
    paotuiFee() {
      this.$router.push("/paotuiFeeTips");
    },
    chooseGoodsType(goodsType) {
      // 如果入库的时候已经选定了包裹规格，下跑腿单的时候不能选择比它更小的规格
      if (this.size && goodsType != 3 && goodsType < this.size) {
        weui.toast("");
      }
      // 先选择大楼和楼层
      if (!this.pickBuildingId) {
        document.getElementById("s1" + goodsType).checked = false;
        weui.alert("请选择大楼");
        return;
      } else if (!this.pickFloor) {
        document.getElementById("s1" + goodsType).checked = false;
        weui.alert("请选择楼层");
        return;
      } else {
        this.goodsType = goodsType;
        if (goodsType != 3) {
          this.goodsDetail = null;
        }
        this.calculate();
      }
    },
    chooseGoodsDetail(item) {
      this.goodsDetail = item;
      this.calculate();
    },
    showBuildingPicker() {
      if (!this.buildingPicker) {
        this.buildingPicker = this.$createPicker({
          title: "楼层选择",
          data: [this.buildings],
          onSelect: this.selectBuildingHandle
        });
      }
      this.buildingPicker.show();
    },
    selectBuildingHandle(selectedVal, selectedIndex, selectedText) {
      if (
        this.buildings[selectedIndex].item.liftSmallFee ||
        this.buildings[selectedIndex].item.smallFeeOne
      ) {
        this.liftSmallFee = this.buildings[selectedIndex].item.liftSmallFee;
        this.liftMiddleFee = this.buildings[selectedIndex].item.liftMiddleFee;
        this.liftBigFee = this.buildings[selectedIndex].item.liftBigFee;
        this.smallFeeOne = this.buildings[selectedIndex].item.smallFeeOne;
        this.smallFeeTwo = this.buildings[selectedIndex].item.smallFeeTwo;
        this.middleFeeOne = this.buildings[selectedIndex].item.middleFeeOne;
        this.middleFeeTwo = this.buildings[selectedIndex].item.middleFeeTwo;
        this.bigFeeOne = this.buildings[selectedIndex].item.bigFeeOne;
        this.bigFeeTwo = this.buildings[selectedIndex].item.bigFeeTwo;
        this.specialGoods = this.buildings[selectedIndex].item.specialGoods;
        this.specialGoods.push({
          _id: -1,
          name: "其他",
          liftFee: this.buildings[selectedIndex].item.liftBigFee,
          feeOne: this.buildings[selectedIndex].item.bigFeeOne,
          feeTwo: this.buildings[selectedIndex].item.bigFeeTwo
        });
      } else {
        this.liftSmallFee = this.worksite.liftSmallFee;
        this.liftMiddleFee = this.worksite.liftMiddleFee;
        this.liftBigFee = this.worksite.liftBigFee;
        this.smallFeeOne = this.worksite.smallFeeOne;
        this.smallFeeTwo = this.worksite.smallFeeTwo;
        this.middleFeeOne = this.worksite.middleFeeOne;
        this.middleFeeTwo = this.worksite.middleFeeTwo;
        this.bigFeeOne = this.worksite.bigFeeOne;
        this.bigFeeTwo = this.worksite.bigFeeTwo;
        // 更新其他选项费用信息
        this.specialGoods = this.worksite.specialGoods;
        this.specialGoods.push({
          _id: -1,
          name: "其他",
          liftFee: this.worksite.liftBigFee,
          feeOne: this.worksite.bigFeeOne,
          feeTwo: this.worksite.bigFeeTwo
        });
      }
      this.pickBuildingId = selectedVal;
      this.pickBuildingTxt = selectedText[0];
      this.isLift = this.buildings[selectedIndex].isLift;
      this.calculate();
    },
    showFloorPicker() {
      if (!this.floorPicker) {
        for (let i = -1; i < 31; i++) {
          if (i == 0) {
            continue;
          } else {
            this.floors.push({
              text: i + "楼",
              value: i
            });
          }
        }
        this.floorPicker = this.$createPicker({
          title: "楼层选择",
          data: [this.floors],
          onSelect: this.selectFloorHandle
        });
      }
      this.floorPicker.show();
    },
    selectFloorHandle(selectedVal, selectedIndex, selectedText) {
      this.pickFloor = selectedVal[0];
      this.calculate();
    },
    calculate() {
      this.fee = 0;
      if (this.goodsType && this.pickBuildingId) {
        if (this.goodsType == 1) {
          if (this.isLift) {
            this.fee = this.liftSmallFee;
          } else {
            if (this.pickFloor && this.pickFloor < 4) {
              this.fee = this.smallFeeOne;
            } else if (this.pickFloor) {
              this.fee = this.smallFeeTwo;
            }
          }
        } else if (this.goodsType == 2) {
          if (this.isLift) {
            this.fee = this.liftMiddleFee;
          } else {
            if (this.pickFloor && this.pickFloor < 4) {
              this.fee = this.middleFeeOne;
            } else if (this.pickFloor) {
              this.fee = this.middleFeeTwo;
            }
          }
        } else if (
          this.goodsType == 3 &&
          this.goodsDetail &&
          this.goodsDetail._id
        ) {
          if (this.isLift) {
            this.fee = this.goodsDetail.liftFee;
          } else {
            if (this.pickFloor && this.pickFloor < 4) {
              this.fee = this.goodsDetail.feeOne;
            } else {
              this.fee = this.goodsDetail.feeTwo;
            }
          }
        }

        // 如果有折扣活动，则需减去活动折扣
        if (this.discountInfo && this.discountInfo._id) {
          if (this.discountInfo.discount) {
            this.discount = (
              (this.fee * (10 - this.discountInfo.discount)) /
              10
            ).toFixed(2);
          } else if (typeof this.discountInfo.fee == "number") {
            this.discount = this.fee - this.discountInfo.fee;
            if (this.discount < 0) {
              this.discount = 0;
            }
          }
          this.payFee = this.fee - this.discount;
        } else {
          this.payFee = this.fee;
        }
      }
    },
    save() {
      if (!this.goodsType) {
        weui.alert("请选择物品类别");
        return;
      } else if (this.goodsType == 3 && !this.goodsDetail) {
        weui.alert("请选择大件分类");
        return;
      } else if (!this.pickBuildingId) {
        weui.alert("请选择大楼");
        return;
      } else if (!this.pickFloor) {
        weui.alert("请选择楼层");
        return;
      } else if (!this.dormRoom) {
        weui.alert("请填入宿舍号码");
        return;
      } else if (this.isProxy && !this.proxyReceiver) {
        weui.alert("请输入代收朋友的姓名");
        return;
      } else if (
        this.isProxy &&
        (!this.proxyReceiverPhone || this.proxyReceiverPhone.length != 11)
      ) {
        weui.alert("请输入代收朋友的正确电话");
        return;
      } else if (!this.fee) {
        weui.alert("赏金不能为空");
        return;
      } else if (!this.worksiteId || !this.schoolCode) {
        weui.alert("获取网点信息失败");
        return;
      }

      this.requireArriveTime =
        moment().format("YYYY-MM-DD") +
        " " +
        this.expressPmDoorServiceEnd +
        ":00";
      let loading = weui.loading("预约单生成中", {
        className: "custom-classname"
      });

      /**
       * 提交生成跑腿订单
       * 需要考虑到一个情况，那就是学生可能会转校区，或者会寄到别的校区
       * 所以发布跑腿任务的时候不能以学生当前所在的校区作为跑腿点
       * worksite 和 schoolCode 要以待配送扫描的网点为准
       */
      let params = {
        toTakeId: this.toTakeId,
        worksite: this.worksiteId,
        schoolCode: this.schoolCode,
        type: 1,
        expressCompanyName: this.excName,
        expressNo: this.expressNo,
        storageNo: this.storageNo,
        tag: this.tag,
        requireArriveTime: this.requireArriveTime,
        initiator: this.userInfo.realname
          ? this.userInfo.realname
          : this.userInfo.nickname.substr(0, 4),
        initiatorPhone: this.userInfo.phoneMain,
        goodsType: this.goodsType,
        goodsName:
          this.goodsDetail && this.goodsDetail.name
            ? this.goodsDetail.name
            : "",
        dormBuilding: this.pickBuildingId,
        dormFloor: this.pickFloor,
        dormRoom: this.dormRoom,
        startPoint: "快递服务中心",
        endPoint: this.pickBuildingTxt + this.pickFloor + "楼" + this.dormRoom,
        estimateWeight: this.weight.code,
        sexLimit: this.sexLimit.value,
        remark: this.remark,
        fee: this.fee * 100,
        payFee: this.payFee * 100
        // fee: 1
      };

      if (this.isBoxStorage) {
        params.isBoxStorage = this.isBoxStorage;
        params.password = this.password;
      }

      if (this.isProxy) {
        params.proxyReceiver = this.proxyReceiver;
        params.proxyReceiverPhone = this.proxyReceiverPhone;
      }

      if (this.canDiscount && this.discountInfo && this.discountInfo._id) {
        params.active = this.discountInfo._id;
      }

      axios
        .post("/api/paotuiOrder", params)
        .then(res => {
          if (res.data.success) {
            if (this.payFee <= 0) {
              // 直接跳转回我发布的进行中跑腿列表
              this.$router.push("/robbingList/1/ing/" + this.encodeToken);
            } else {
              let paotuiId = res.data.data._id;
              this.$router.push(
                "/orderSuccess/" + paotuiId + "/" + this.encodeToken
              );
            }
            loading.hide(function () { });
          } else {
            loading.hide(function () { });
            weui.alert(res.data.message);
            return;
          }
        })
        .catch(err => {
          console.log(err);
          loading.hide(function () { });
          weui.alert("生成跑腿单失败");
          return;
        });
    }
  }
};
</script>

<style scoped>
.redTips {
  color: red;
  position: relative;
  top: 2px;
  vertical-align: middle;
  font-weight: bold;
}

.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}

.mail-tips {
  font-size: 16px;
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}

.address-error {
  color: red;
}

.warehousing-footer-item {
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  line-height: 50px;
  color: #ffffff;
}

.warehousing-footer-item-disable {
  background-color: #cccccc;
}

.warehousing-footer-item a {
  color: #ffffff;
}

.shangjin {
  background-color: orangered;
}

.weui-cells:last-child::after {
  border-bottom: none;
}

.need {
  font-weight: bold;
  color: orangered;
}

.discount-info {
  padding: 4px;
  padding-left: 15px;
  background-color: lightyellow;
}

.discount-info i {
  color: orangered;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}

.unable-radio {
  color: #ccc;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/DoorService.vue